<template>
    <div class="paycard-wrap">
        <swiper :options="swiperOptions">
            <swiper-slide v-for="(item, index) in slideData" :key="item.id">
                <div class="image-area">
                    <img :src="item.cardImg" alt="" />
                </div>
            </swiper-slide>
        </swiper>
    </div>
</template>

<script>
    import { Swiper, SwiperSlide } from "vue-awesome-swiper";
    import "swiper/css/swiper.css";
    
    export default {
        name: 'EmarticonCard',
        components: { Swiper, SwiperSlide },
        props: ['slideData'],
        data() {
            return {
                swiperOptions: { 
                    slidesPerView: 'auto', 
                    spaceBetween: 10, 
                    centeredSlides: true,
                    // loop: true
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/common/paymentCard.scss';
</style>